import script from "./FlyerGeneralInfoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlyerGeneralInfoView.vue?vue&type=script&setup=true&lang=ts"

import "./FlyerGeneralInfoView.vue?vue&type=style&index=0&id=1e686aa9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e686aa9"]])

export default __exports__